import { ReportStatus } from '../../../apis/graphql/types';
import { StatusColor } from '../../../constants';

export const ReportStatusUI = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
  SCHEDULED: 'SCHEDULED',
  STOPPED: 'STOPPED',
  READY: 'READY',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ReportStatusUI = (typeof ReportStatusUI)[keyof typeof ReportStatusUI];

export const REPORT_STATUS_MAP: Record<ReportStatus, string> = {
  [ReportStatus.Complete]: 'Complete',
  [ReportStatus.Failed]: 'Failed',
  [ReportStatus.Delayed]: 'No Data',
  [ReportStatus.Pending]: 'Processing',
  [ReportStatus.Ready]: 'Ready',
  [ReportStatus.Scheduled]: 'Scheduled',
  [ReportStatus.Stopped]: 'Stopped',
};

export const REPORT_STATUS_MAP_FOR_FILTER = {
  COMPLETE: [ReportStatus.Complete],
  FAILED: [ReportStatus.Failed],
  PENDING: [ReportStatus.Pending],
  READY: [ReportStatus.Ready],
  SCHEDULED: [ReportStatus.Scheduled],
  STOPPED: [ReportStatus.Stopped],
};

export const getReportStatusForUI = (status?: ReportStatus): string => REPORT_STATUS_MAP[status as ReportStatus];

export const getFilteredReportStatusUI = (status: ReportStatusUI | ''): ReportStatus[] | undefined =>
  status ? REPORT_STATUS_MAP_FOR_FILTER[status] : undefined;

export const REPORT_STATUS_COLORS_MAP: Record<ReportStatus, StatusColor> = {
  COMPLETE: StatusColor.GREEN,
  READY: StatusColor.BLUE,
  PENDING: StatusColor.BLUE,
  SCHEDULED: StatusColor.GRAY,
  STOPPED: StatusColor.RED,
  FAILED: StatusColor.RED,
  DELAYED: StatusColor.RED,
};
